import { v1ApiClient } from '@/services';
import type { Operation, Schema } from '@/shared/api/generated';

type UpdateReportOperation = Operation<'UpdateReport'>;
type UpdateReportBody = Partial<Schema<'UpdateReportRequest'>> &
  Pick<Schema<'UpdateReportRequest'>, 'title'>;

export type UpdateReportParams =
  UpdateReportOperation['parameters']['path'] & UpdateReportBody;

export type UpdateReportResponse = Schema<'Report'>;

export const updateReport = ({
  report_id,
  ...body
}: UpdateReportParams): Promise<UpdateReportResponse> =>
  v1ApiClient.put(`/reports/${report_id}`, body).then((res) => res.data);
